import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CallUsBanner = () => {
  const handleCall = () => {
    window.location.href = "tel:+1-877-254-8655"; // Replace with your actual phone number
  };

  return (
    <div className="container-fluid bg-warning text-white p-4 rounded border shadow-lg">
      <div className="row align-items-center">
        <div className="col-md-8">
          <h4 className="fw-bold text-primary">Do You Need Help?</h4>
          <p className="fw-bold">
            Flight Booking is here to assist you. Feel free to call us. <br />
            Happy to help you...
          </p>
        </div>
        <div className="col-md-4 text-md-end text-center">
          <button className="btn btn-primary rounded-pill px-4 py-2 shadow" onClick={handleCall}>
            CALL US NOW
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallUsBanner;
